/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DockerWorkerConfigV3LightlyCheckpointCallback } from './DockerWorkerConfigV3LightlyCheckpointCallback';
import { DockerWorkerConfigV3LightlyCheckpointCallbackFromJSON, DockerWorkerConfigV3LightlyCheckpointCallbackFromJSONTyped, DockerWorkerConfigV3LightlyCheckpointCallbackToJSON, } from './DockerWorkerConfigV3LightlyCheckpointCallback';
import type { DockerWorkerConfigV3LightlyCollate } from './DockerWorkerConfigV3LightlyCollate';
import { DockerWorkerConfigV3LightlyCollateFromJSON, DockerWorkerConfigV3LightlyCollateFromJSONTyped, DockerWorkerConfigV3LightlyCollateToJSON, } from './DockerWorkerConfigV3LightlyCollate';
import type { DockerWorkerConfigV3LightlyCriterion } from './DockerWorkerConfigV3LightlyCriterion';
import { DockerWorkerConfigV3LightlyCriterionFromJSON, DockerWorkerConfigV3LightlyCriterionFromJSONTyped, DockerWorkerConfigV3LightlyCriterionToJSON, } from './DockerWorkerConfigV3LightlyCriterion';
import type { DockerWorkerConfigV3LightlyLoader } from './DockerWorkerConfigV3LightlyLoader';
import { DockerWorkerConfigV3LightlyLoaderFromJSON, DockerWorkerConfigV3LightlyLoaderFromJSONTyped, DockerWorkerConfigV3LightlyLoaderToJSON, } from './DockerWorkerConfigV3LightlyLoader';
import type { DockerWorkerConfigV3LightlyModel } from './DockerWorkerConfigV3LightlyModel';
import { DockerWorkerConfigV3LightlyModelFromJSON, DockerWorkerConfigV3LightlyModelFromJSONTyped, DockerWorkerConfigV3LightlyModelToJSON, } from './DockerWorkerConfigV3LightlyModel';
import type { DockerWorkerConfigV3LightlyOptimizer } from './DockerWorkerConfigV3LightlyOptimizer';
import { DockerWorkerConfigV3LightlyOptimizerFromJSON, DockerWorkerConfigV3LightlyOptimizerFromJSONTyped, DockerWorkerConfigV3LightlyOptimizerToJSON, } from './DockerWorkerConfigV3LightlyOptimizer';
import type { DockerWorkerConfigV3LightlyTrainer } from './DockerWorkerConfigV3LightlyTrainer';
import { DockerWorkerConfigV3LightlyTrainerFromJSON, DockerWorkerConfigV3LightlyTrainerFromJSONTyped, DockerWorkerConfigV3LightlyTrainerToJSON, } from './DockerWorkerConfigV3LightlyTrainer';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * Lightly configurations which are passed to a Lightly Worker run. For information
 * about the options see https://docs.lightly.ai/docs/all-configuration-options#run-configuration.
 * @export
 * @interface DockerWorkerConfigV3Lightly
 *
 */
// create custom validators for the regexes
export interface DockerWorkerConfigV3Lightly {
    /**
     * Random seed.
     * #type number
     * #memberof DockerWorkerConfigV3Lightly
        * @type int
        
         */
    seed?: number;
    /**
     *
     * #type DockerWorkerConfigV3LightlyCheckpointCallback
     * #memberof DockerWorkerConfigV3Lightly
        
        
         */
    checkpointCallback?: DockerWorkerConfigV3LightlyCheckpointCallback;
    /**
     *
     * #type DockerWorkerConfigV3LightlyLoader
     * #memberof DockerWorkerConfigV3Lightly
        
        
         */
    loader?: DockerWorkerConfigV3LightlyLoader;
    /**
     *
     * #type DockerWorkerConfigV3LightlyModel
     * #memberof DockerWorkerConfigV3Lightly
        
        
         */
    model?: DockerWorkerConfigV3LightlyModel;
    /**
     *
     * #type DockerWorkerConfigV3LightlyTrainer
     * #memberof DockerWorkerConfigV3Lightly
        
        
         */
    trainer?: DockerWorkerConfigV3LightlyTrainer;
    /**
     *
     * #type DockerWorkerConfigV3LightlyCriterion
     * #memberof DockerWorkerConfigV3Lightly
        
        
         */
    criterion?: DockerWorkerConfigV3LightlyCriterion;
    /**
     *
     * #type DockerWorkerConfigV3LightlyOptimizer
     * #memberof DockerWorkerConfigV3Lightly
        
        
         */
    optimizer?: DockerWorkerConfigV3LightlyOptimizer;
    /**
     *
     * #type DockerWorkerConfigV3LightlyCollate
     * #memberof DockerWorkerConfigV3Lightly
        
        
         */
    collate?: DockerWorkerConfigV3LightlyCollate;
}
/**
 * Check if a given object implements the DockerWorkerConfigV3Lightly interface.
 */
export function instanceOfDockerWorkerConfigV3Lightly(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DockerWorkerConfigV3LightlyCheckpointCallbackValidator, DockerWorkerConfigV3LightlyCheckpointCallbackStringifyShape, DockerWorkerConfigV3LightlyCheckpointCallbackStringifyShapeProperties, } from './DockerWorkerConfigV3LightlyCheckpointCallback';
import { DockerWorkerConfigV3LightlyCollateValidator, DockerWorkerConfigV3LightlyCollateStringifyShape, DockerWorkerConfigV3LightlyCollateStringifyShapeProperties, } from './DockerWorkerConfigV3LightlyCollate';
import { DockerWorkerConfigV3LightlyCriterionValidator, DockerWorkerConfigV3LightlyCriterionStringifyShape, DockerWorkerConfigV3LightlyCriterionStringifyShapeProperties, } from './DockerWorkerConfigV3LightlyCriterion';
import { DockerWorkerConfigV3LightlyLoaderValidator, DockerWorkerConfigV3LightlyLoaderStringifyShape, DockerWorkerConfigV3LightlyLoaderStringifyShapeProperties, } from './DockerWorkerConfigV3LightlyLoader';
import { DockerWorkerConfigV3LightlyModelValidator, DockerWorkerConfigV3LightlyModelStringifyShape, DockerWorkerConfigV3LightlyModelStringifyShapeProperties, } from './DockerWorkerConfigV3LightlyModel';
import { DockerWorkerConfigV3LightlyOptimizerValidator, DockerWorkerConfigV3LightlyOptimizerStringifyShape, DockerWorkerConfigV3LightlyOptimizerStringifyShapeProperties, } from './DockerWorkerConfigV3LightlyOptimizer';
import { DockerWorkerConfigV3LightlyTrainerValidator, DockerWorkerConfigV3LightlyTrainerStringifyShape, DockerWorkerConfigV3LightlyTrainerStringifyShapeProperties, } from './DockerWorkerConfigV3LightlyTrainer';
export const DockerWorkerConfigV3LightlyTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerWorkerConfigV3Lightly => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerWorkerConfigV3Lightly => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.seed || "number" === typeof input.seed && Math.floor(input.seed) === input.seed && (-2147483648 <= input.seed && input.seed <= 2147483647)) && (undefined === input.checkpointCallback || "object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) && $io1(input.checkpointCallback, true && _exceptionable)) && (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io2(input.loader, true && _exceptionable)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io3(input.model, true && _exceptionable)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io4(input.trainer, true && _exceptionable)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io5(input.criterion, true && _exceptionable)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io6(input.optimizer, true && _exceptionable)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io7(input.collate, true && _exceptionable)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["seed", "checkpointCallback", "loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.saveLast || "boolean" === typeof input.saveLast) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["saveLast"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io4 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io5 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && 0 < input.temperature) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["temperature"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io6 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["lr", "weightDecay"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io7 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (null === input.rrDegrees || undefined === input.rrDegrees || Array.isArray(input.rrDegrees) && input.rrDegrees.every((elem: any, _index2: number) => "number" === typeof elem)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb", "rrDegrees"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV3Lightly => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.seed || "number" === typeof input.seed && (Math.floor(input.seed) === input.seed || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) && (-2147483648 <= input.seed && input.seed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "(number | undefined)",
                    value: input.seed
                })) && (undefined === input.checkpointCallback || ("object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && $ao1(input.checkpointCallback, _path + ".checkpointCallback", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao2(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && $ao3(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao4(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao5(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao6(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao7(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["seed", "checkpointCallback", "loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.saveLast || "boolean" === typeof input.saveLast || $guard(_exceptionable, {
                    path: _path + ".saveLast",
                    expected: "(boolean | undefined)",
                    value: input.saveLast
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["saveLast"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["temperature"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && (0 <= input.lr || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "number (@minimum 0)",
                    value: input.lr
                })) || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "(number | undefined)",
                    value: input.lr
                })) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && (0 <= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@minimum 0)",
                    value: input.weightDecay
                })) && (1 >= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@maximum 1)",
                    value: input.weightDecay
                })) || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "(number | undefined)",
                    value: input.weightDecay
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["lr", "weightDecay"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                })) && (null === input.rrDegrees || undefined === input.rrDegrees || (Array.isArray(input.rrDegrees) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                })) && input.rrDegrees.every((elem: any, _index2: number) => "number" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".rrDegrees[" + _index2 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb", "rrDegrees"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3Lightly",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3Lightly",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerWorkerConfigV3LightlyTypiaAssertStringify = (input: DockerWorkerConfigV3Lightly): string => {
    return ((input: any): string => { const assert = (input: any): DockerWorkerConfigV3Lightly => {
        const __is = (input: any): input is DockerWorkerConfigV3Lightly => {
            const $io0 = (input: any): boolean => (undefined === input.seed || "number" === typeof input.seed && !Number.isNaN(input.seed) && Math.floor(input.seed) === input.seed && (-2147483648 <= input.seed && input.seed <= 2147483647)) && (undefined === input.checkpointCallback || "object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) && $io1(input.checkpointCallback)) && (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io2(input.loader)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io3(input.model)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io4(input.trainer)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io5(input.criterion)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io6(input.optimizer)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io7(input.collate));
            const $io1 = (input: any): boolean => undefined === input.saveLast || "boolean" === typeof input.saveLast;
            const $io2 = (input: any): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast);
            const $io3 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
            const $io4 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
            const $io5 = (input: any): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && 0 < input.temperature;
            const $io6 = (input: any): boolean => (undefined === input.lr || "number" === typeof input.lr && !Number.isNaN(input.lr) && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay);
            const $io7 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem && !Number.isNaN(elem))) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (null === input.rrDegrees || undefined === input.rrDegrees || Array.isArray(input.rrDegrees) && input.rrDegrees.every((elem: any) => "number" === typeof elem && !Number.isNaN(elem)));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV3Lightly => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.seed || "number" === typeof input.seed && !Number.isNaN(input.seed) && (Math.floor(input.seed) === input.seed || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) && (-2147483648 <= input.seed && input.seed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "(number | undefined)",
                    value: input.seed
                })) && (undefined === input.checkpointCallback || ("object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && $ao1(input.checkpointCallback, _path + ".checkpointCallback", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao2(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && $ao3(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao4(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao5(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao6(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao7(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.saveLast || "boolean" === typeof input.saveLast || $guard(_exceptionable, {
                    path: _path + ".saveLast",
                    expected: "(boolean | undefined)",
                    value: input.saveLast
                });
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                }));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                }));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                }));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                });
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && !Number.isNaN(input.lr) && (0 <= input.lr || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "number (@minimum 0)",
                    value: input.lr
                })) || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "(number | undefined)",
                    value: input.lr
                })) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && (0 <= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@minimum 0)",
                    value: input.weightDecay
                })) && (1 >= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@maximum 1)",
                    value: input.weightDecay
                })) || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "(number | undefined)",
                    value: input.weightDecay
                }));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem && !Number.isNaN(elem) || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                })) && (null === input.rrDegrees || undefined === input.rrDegrees || (Array.isArray(input.rrDegrees) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                })) && input.rrDegrees.every((elem: any, _index2: number) => "number" === typeof elem && !Number.isNaN(elem) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees[" + _index2 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                }));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3Lightly",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3Lightly",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerWorkerConfigV3Lightly): string => {
        const $io1 = (input: any): boolean => undefined === input.saveLast || "boolean" === typeof input.saveLast;
        const $io2 = (input: any): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast);
        const $io3 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
        const $io4 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
        const $io5 = (input: any): boolean => undefined === input.temperature || "number" === typeof input.temperature && 0 < input.temperature;
        const $io6 = (input: any): boolean => (undefined === input.lr || "number" === typeof input.lr && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay);
        const $io7 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (null === input.rrDegrees || undefined === input.rrDegrees || Array.isArray(input.rrDegrees) && input.rrDegrees.every((elem: any) => "number" === typeof elem));
        const $tail = (typia.createAssertStringify as any).tail;
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $so0 = (input: any): any => `{${$tail(`${undefined === input.seed ? "" : `"seed":${undefined !== input.seed ? input.seed : undefined},`}${undefined === input.checkpointCallback ? "" : `"checkpointCallback":${undefined !== input.checkpointCallback ? $so1(input.checkpointCallback) : undefined},`}${undefined === input.loader ? "" : `"loader":${undefined !== input.loader ? $so2(input.loader) : undefined},`}${undefined === input.model ? "" : `"model":${undefined !== input.model ? $so3(input.model) : undefined},`}${undefined === input.trainer ? "" : `"trainer":${undefined !== input.trainer ? $so4(input.trainer) : undefined},`}${undefined === input.criterion ? "" : `"criterion":${undefined !== input.criterion ? $so5(input.criterion) : undefined},`}${undefined === input.optimizer ? "" : `"optimizer":${undefined !== input.optimizer ? $so6(input.optimizer) : undefined},`}${undefined === input.collate ? "" : `"collate":${undefined !== input.collate ? $so7(input.collate) : undefined}`}`)}}`;
        const $so1 = (input: any): any => `{${$tail(`${undefined === input.saveLast ? "" : `"saveLast":${undefined !== input.saveLast ? input.saveLast : undefined}`}`)}}`;
        const $so2 = (input: any): any => `{${$tail(`${undefined === input.batchSize ? "" : `"batchSize":${undefined !== input.batchSize ? input.batchSize : undefined},`}${undefined === input.shuffle ? "" : `"shuffle":${undefined !== input.shuffle ? input.shuffle : undefined},`}${undefined === input.numWorkers ? "" : `"numWorkers":${undefined !== input.numWorkers ? input.numWorkers : undefined},`}${undefined === input.dropLast ? "" : `"dropLast":${undefined !== input.dropLast ? input.dropLast : undefined}`}`)}}`;
        const $so3 = (input: any): any => `{${$tail(`${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.outDim ? "" : `"outDim":${undefined !== input.outDim ? input.outDim : undefined},`}${undefined === input.numFtrs ? "" : `"numFtrs":${undefined !== input.numFtrs ? input.numFtrs : undefined},`}${undefined === input.width ? "" : `"width":${undefined !== input.width ? input.width : undefined}`}`)}}`;
        const $so4 = (input: any): any => `{${$tail(`${undefined === input.gpus ? "" : `"gpus":${undefined !== input.gpus ? input.gpus : undefined},`}${undefined === input.maxEpochs ? "" : `"maxEpochs":${undefined !== input.maxEpochs ? input.maxEpochs : undefined},`}${undefined === input.precision ? "" : `"precision":${undefined !== input.precision ? input.precision : undefined}`}`)}}`;
        const $so5 = (input: any): any => `{${$tail(`${undefined === input.temperature ? "" : `"temperature":${undefined !== input.temperature ? input.temperature : undefined}`}`)}}`;
        const $so6 = (input: any): any => `{${$tail(`${undefined === input.lr ? "" : `"lr":${undefined !== input.lr ? input.lr : undefined},`}${undefined === input.weightDecay ? "" : `"weightDecay":${undefined !== input.weightDecay ? input.weightDecay : undefined}`}`)}}`;
        const $so7 = (input: any): any => `{${$tail(`${undefined === input.inputSize ? "" : `"inputSize":${undefined !== input.inputSize ? input.inputSize : undefined},`}${undefined === input.cjProb ? "" : `"cjProb":${undefined !== input.cjProb ? input.cjProb : undefined},`}${undefined === input.cjBright ? "" : `"cjBright":${undefined !== input.cjBright ? input.cjBright : undefined},`}${undefined === input.cjContrast ? "" : `"cjContrast":${undefined !== input.cjContrast ? input.cjContrast : undefined},`}${undefined === input.cjSat ? "" : `"cjSat":${undefined !== input.cjSat ? input.cjSat : undefined},`}${undefined === input.cjHue ? "" : `"cjHue":${undefined !== input.cjHue ? input.cjHue : undefined},`}${undefined === input.minScale ? "" : `"minScale":${undefined !== input.minScale ? input.minScale : undefined},`}${undefined === input.randomGrayScale ? "" : `"randomGrayScale":${undefined !== input.randomGrayScale ? input.randomGrayScale : undefined},`}${undefined === input.gaussianBlur ? "" : `"gaussianBlur":${undefined !== input.gaussianBlur ? input.gaussianBlur : undefined},`}${undefined === input.kernelSize ? "" : `"kernelSize":${undefined !== input.kernelSize ? input.kernelSize : undefined},`}${undefined === input.sigmas ? "" : `"sigmas":${undefined !== input.sigmas ? `[${input.sigmas.map((elem: any) => elem).join(",")}]` : undefined},`}${undefined === input.vfProb ? "" : `"vfProb":${undefined !== input.vfProb ? input.vfProb : undefined},`}${undefined === input.hfProb ? "" : `"hfProb":${undefined !== input.hfProb ? input.hfProb : undefined},`}${undefined === input.rrProb ? "" : `"rrProb":${undefined !== input.rrProb ? input.rrProb : undefined},`}${undefined === input.rrDegrees ? "" : `"rrDegrees":${undefined !== input.rrDegrees ? null !== input.rrDegrees ? `[${input.rrDegrees.map((elem: any) => elem).join(",")}]` : "null" : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerWorkerConfigV3LightlyValidatorShape = {
    'seed': yup.number().integer(),
    'checkpointCallback': DockerWorkerConfigV3LightlyCheckpointCallbackValidator.optional().default(undefined),
    'loader': DockerWorkerConfigV3LightlyLoaderValidator.optional().default(undefined),
    'model': DockerWorkerConfigV3LightlyModelValidator.optional().default(undefined),
    'trainer': DockerWorkerConfigV3LightlyTrainerValidator.optional().default(undefined),
    'criterion': DockerWorkerConfigV3LightlyCriterionValidator.optional().default(undefined),
    'optimizer': DockerWorkerConfigV3LightlyOptimizerValidator.optional().default(undefined),
    'collate': DockerWorkerConfigV3LightlyCollateValidator.optional().default(undefined),
};
export const DockerWorkerConfigV3LightlyValidator = yup.object().shape(DockerWorkerConfigV3LightlyValidatorShape);
export const DockerWorkerConfigV3LightlyStringifyShapeProperties: ObjectSchema['properties'] = {
    'seed': {
        'type': 'integer',
    } as unknown as fastJSON.IntegerSchema,
    'checkpointCallback': DockerWorkerConfigV3LightlyCheckpointCallbackStringifyShape,
    'loader': DockerWorkerConfigV3LightlyLoaderStringifyShape,
    'model': DockerWorkerConfigV3LightlyModelStringifyShape,
    'trainer': DockerWorkerConfigV3LightlyTrainerStringifyShape,
    'criterion': DockerWorkerConfigV3LightlyCriterionStringifyShape,
    'optimizer': DockerWorkerConfigV3LightlyOptimizerStringifyShape,
    'collate': DockerWorkerConfigV3LightlyCollateStringifyShape,
};
export const DockerWorkerConfigV3LightlyStringifyShape: ObjectSchema = {
    title: 'DockerWorkerConfigV3Lightly Stringifier',
    type: 'object',
    properties: {
        ...DockerWorkerConfigV3LightlyStringifyShapeProperties
    },
    required: [],
};
export const DockerWorkerConfigV3LightlyStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerWorkerConfigV3LightlyStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerWorkerConfigV3LightlyStringify: (data: DockerWorkerConfigV3Lightly) => string = DockerWorkerConfigV3LightlyStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerWorkerConfigV3LightlyFromJSON(json: any): DockerWorkerConfigV3Lightly {
    return DockerWorkerConfigV3LightlyFromJSONTyped(json, false);
}
export function DockerWorkerConfigV3LightlyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerWorkerConfigV3Lightly {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'seed': !exists(json, 'seed') ? undefined : json['seed'],
        'checkpointCallback': !exists(json, 'checkpointCallback') ? undefined : DockerWorkerConfigV3LightlyCheckpointCallbackFromJSON(json['checkpointCallback']),
        'loader': !exists(json, 'loader') ? undefined : DockerWorkerConfigV3LightlyLoaderFromJSON(json['loader']),
        'model': !exists(json, 'model') ? undefined : DockerWorkerConfigV3LightlyModelFromJSON(json['model']),
        'trainer': !exists(json, 'trainer') ? undefined : DockerWorkerConfigV3LightlyTrainerFromJSON(json['trainer']),
        'criterion': !exists(json, 'criterion') ? undefined : DockerWorkerConfigV3LightlyCriterionFromJSON(json['criterion']),
        'optimizer': !exists(json, 'optimizer') ? undefined : DockerWorkerConfigV3LightlyOptimizerFromJSON(json['optimizer']),
        'collate': !exists(json, 'collate') ? undefined : DockerWorkerConfigV3LightlyCollateFromJSON(json['collate']),
    };
}
export function DockerWorkerConfigV3LightlyToJSON(value?: DockerWorkerConfigV3Lightly | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'seed': value.seed,
        'checkpointCallback': DockerWorkerConfigV3LightlyCheckpointCallbackToJSON(value.checkpointCallback),
        'loader': DockerWorkerConfigV3LightlyLoaderToJSON(value.loader),
        'model': DockerWorkerConfigV3LightlyModelToJSON(value.model),
        'trainer': DockerWorkerConfigV3LightlyTrainerToJSON(value.trainer),
        'criterion': DockerWorkerConfigV3LightlyCriterionToJSON(value.criterion),
        'optimizer': DockerWorkerConfigV3LightlyOptimizerToJSON(value.optimizer),
        'collate': DockerWorkerConfigV3LightlyCollateToJSON(value.collate),
    };
}
